import React, { useState, useEffect } from 'react';
import { StoreSelector } from '../StoreSelector';
import { Modal } from '../Modal';
import { useDialogState } from '../Dialog/useDialogState';

const StoreSelectorBanner = () => {
  const [zipCode, setZipCode] = useState('');
  const dialogState = useDialogState();
  const { modalTriggerRef, openModal } = dialogState;

  useEffect(() => {
    document.addEventListener('find-store', openModal);

    return () => document.removeEventListener('find-store', openModal);
  }, [openModal]);

  const handleSubmit = (event) => {
    event.preventDefault();

    openModal();
  };

  return (
    <form className="cmp-store-banner__form" onSubmit={handleSubmit}>
      <div className="cmp-store-banner__input-wrapper">
        <label htmlFor="banner-zip-code-input" className="util-visually-hidden">
          Enter ZIP code
        </label>
        <input
          id="banner-zip-code-input"
          type="text"
          name="zip-code"
          value={zipCode}
          className="cmp-store-banner__input"
          placeholder="ZIP code"
          pattern="^[0-9]{5}?$"
          inputMode="numeric"
          maxLength="5"
          minLength="5"
          onChange={(event) => setZipCode(event.target.value)}
          data-testid="find-store-input"
        />
      </div>
      <div>
        <button
          type="submit"
          className="cmp-cta-link"
          onClick={openModal}
          ref={modalTriggerRef}
          data-testid="find-store-button"
        >
          <span>Find a Store</span>
        </button>
        <Modal
          title="Find a Store"
          className="modal--overflow"
          dialogState={dialogState}
        >
          <StoreSelector zipCode={zipCode} setZipCode={setZipCode} />
        </Modal>
      </div>
    </form>
  );
};

export { StoreSelectorBanner };
